// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__33mlt","titleText":"styles_titleText__3-9E4"};